import React from 'react';
import {
  Box, Hidden, Radio, withStyles,
} from '@material-ui/core';
import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';
import ThumbUpAltOutlinedIcon from '@material-ui/icons/ThumbUpAltOutlined';
import config from '@/configs/config';
import { FavBox, FavButton } from './Providers';

const StyleRadio = withStyles({
  root: {
    color: 'black',
    backgroundColor: '#f5f5f5',
    borderRadius: 8,
    boxShadow: '0px 2px 4px 0px rgba(0,0,0,0.5)',
    padding: 0,
    transition: 'none',
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
    '&$checked': {
      color: 'black',
    },
  },
  checked: {
    backgroundColor: '#f5f5f5',
    '&:hover': {
      backgroundColor: '#f5f5f5 !important',
    },
  },
})(Radio);

const LikeButton = ({ checked, rotate }) => (
  <StyleRadio
    checked={checked}
    checkedIcon={<ThumbUpAltIcon style={rotate && { transform: 'rotate(180deg)' }} />}
    icon={<ThumbUpAltOutlinedIcon style={rotate && { transform: 'rotate(180deg)' }} />}
  />
);

const Product = ({ data, onFavoriteButtonClick }) => {
  const {
    calories, id, ingredients, isDisliked, isLiked, name, price,
  } = data || {};
  return (
    <Box>
      <Box
        alignItems="center"
        display="flex"
        fontWeight="bold"
        justifyContent="space-between"
      >
        <Box>
          {name}
        </Box>
        <Box display="flex" alignItems="center">
          <Box>
            {'$'}
            {' '}
            {price}
          </Box>
          <Box
            ml={1}
            onClick={async () => {
              await onFavoriteButtonClick({
                itemId: id,
                type: 'LIKE',
                itemType: 'PRODUCT',
              });
            }}
          >
            <LikeButton checked={isLiked} />
          </Box>
          <Box
            ml={1}
            onClick={async () => {
              await onFavoriteButtonClick({
                itemId: id,
                type: 'DISLIKE',
                itemType: 'PRODUCT',
              });
            }}
          >
            <LikeButton checked={isDisliked} rotate />
          </Box>
        </Box>
      </Box>
      <Box color="#4f4f4f" fontSize={13}>{ingredients}</Box>
      {calories && (
      <Box color="#589664" fontSize={13}>
        參考熱量：
        {calories}
      </Box>
      )}
    </Box>
  );
};

export default ({
  data,
  onFavoriteButtonClick,
}) => {
  const {
    coverImage, encodedProviderName, introduction, isLiked, name, products,
  } = data || {};
  return (
    <Box>
      <Box position="relative">
        <FavBox onClick={async () => {
          await onFavoriteButtonClick({
            itemId: encodedProviderName,
            itemType: 'PROVIDER',
            type: 'LIKE',
          });
        }}
        >
          <FavButton checked={isLiked} />
        </FavBox>
        <img
          src={`${config.RESOURCE_URI}${coverImage}`}
          width="100%"
          alt=""
          key={coverImage}
          onError={(e) => {
            e.currentTarget.src = `${config.RESOURCE_URI}logo.png`;
          }}
        />
      </Box>
      <Box py={3} px={{ xs: 4, sm: 5 }}>
        <Box fontWeight="bold" fontSize={16}>
          【
          {name}
          】
        </Box>
        <Box fontSize={13} color="#4f4f4f">
          {introduction}
        </Box>
        <Hidden smUp>
          <Box borderTop={2} width={120} borderColor="#000000" mx="auto" my={2.5} />
        </Hidden>
        <Box mt={{ sm: 5 }} display="flex" flexWrap="wrap">
          {(products || []).map((product) => {
            const { id } = product;

            return (
              <Box flexBasis={{ xs: '100%', sm: '50%' }} p={1} key={id}>
                <Product data={product} onFavoriteButtonClick={onFavoriteButtonClick} />
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};
